import React, { Suspense, lazy } from "react";
import {BrowserRouter,Routes, Route } from "react-router-dom";
import Main from "./components/section/Main";

const Home = lazy(()=>import('./page/Home'));
const Company = lazy(()=>import('./page/Company'));
const Lathe = lazy(()=>import('./page/Lathe'));
const Mill = lazy(()=>import('./page/Mill'));
const Machine_etc = lazy(()=>import('./page/Machine_etc'));
const Shaft_img = lazy(()=>import('./page/Shaft_img'))
const Question = lazy(()=>import('./page/Question'));
const Steel_img = lazy(()=>import('./page/Steel_img'));
const Sus_img = lazy(()=>import('./page/Sus_img'));
const Al_img = lazy(()=>import('./page/Al_img'));
const MCetc_img = lazy(()=>import('./page/MCetc_img'));



const App=()=>{

  return(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Suspense fallback={<Main/>}>
        <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/company" element={<Company />}/>
          <Route path="/lathe" element={<Lathe />}/>
          <Route path="/mill" element={<Mill />}/>
          <Route path="/machine_etc" element={<Machine_etc />}/>
          <Route path="/Shaft_img" element={<Shaft_img />}/>
          <Route path="/Steel_img" element={<Steel_img />}/>
          <Route path="/Sus_img" element={<Sus_img />}/>
          <Route path="/Al_img" element={<Al_img />}/>
          <Route path="/MCetc_img" element={<MCetc_img />}/>
          <Route path="/question" element={<Question />}/>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )

}

export default App;